module.exports = __webpack_public_path__ + "img/6pm_logo@2x.465d9da1.png";